import { PauseIcon, PlayIcon } from '@/components/Icons';
import Show from '@/components/Show';
import { AudioDto } from '@/service/type';
import useEditorStore, { EditorOperatorEnum } from '@/state/editor-store';
import useGeneratorStore from '@/state/generator-store';
import { useCallback, useEffect, useRef, useState } from 'react';
import { AudioEditor } from '../../module/AudioEditor';
import useFlags from '@jenmusic/feature-flag';
import { FEATURE_FLAG_CONFIG } from '@/config';
import { AudioDetailDto } from '@/service/interface';

const WaveformDiv = () => {
  const { setLoading, editor, setEditor, operator } = useEditorStore((state) => ({
    setLoading: state.setLoading,
    editor: state.editor,
    setEditor: state.setEditor,
    operator: state.operator,
  }));

  const { audioInfo } = useGeneratorStore((state) => ({
    audioInfo: state.audioInfo,
  }));

  const { showBarsBeats } = useFlags<typeof FEATURE_FLAG_CONFIG>();

  const containerRef = useRef<HTMLDivElement>(null);
  const editorRef = useRef<AudioEditor | null>(null);

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setLoading(true);
      console.log('set true');
      editorRef.current = AudioEditor.getInstance((audioInfo as AudioDto).source_url, containerRef.current, undefined, {
        flag: showBarsBeats,
        bpm: (audioInfo as AudioDetailDto)?.metadata?.bpm,
        timeOffset: (audioInfo as AudioDetailDto)?.metadata?.first_beat_sec,
      });
      setEditor(editorRef.current);
      editorRef.current.setReadyCallback(() => {
        setLoading(false);
        console.log('set false');
      });
    }
  }, []);

  const onPlayPause = useCallback(() => {
    if (editor) {
      if (isPlaying) {
        setIsPlaying(false);
        editor.pause();
      } else {
        setIsPlaying(true);
        editor.play();
      }
    }
  }, [isPlaying, editor]);

  return (
    <div className="flex w-full h-full">
      <Show when={operator === EditorOperatorEnum.INTRO}>
        <div className="region-content flex">
          <div className="audio-editor-waveform-region">
            <div className="w-12 h-[20px] px-2.5 py-[5px] bg-[#1e1f21] rounded-sm justify-center items-center gap-2.5 inline-flex m-2">
              <div className="text-[#ff5b27] text-[10px] font-normal font-['GT Pressura Mono Trial'] uppercase leading-normal">INTRO</div>
            </div>
          </div>
        </div>
      </Show>
      <div className="flex w-full h-full items-center relative">
        <button
          onClick={onPlayPause}
          type="button"
          className={`flex items-center justify-center w-14 h-14 rounded-full z-10 absolute ml-4 transition duration-200 hover:brightness-110
            ${!isPlaying && editor?.getCurrentTime() === 0 ? 'bg-jen-orange' : 'bg-jen-black'}
          `}
        >
          {isPlaying ? <PauseIcon className="w-8 h-8" fillColor="#fff" /> : <PlayIcon className="w-8 h-8" fillColor="#fff" />}
        </button>
        <div ref={containerRef} className="w-full h-full flex absolute inset-0" id="audio-editor-waveform" />
      </div>
      <Show when={operator === EditorOperatorEnum.OUTRO}>
        <div className="region-content flex">
          <div className="audio-editor-waveform-region">
            <div className="w-12 h-[20px] px-2.5 py-[5px] bg-[#1e1f21] rounded-sm justify-center items-center gap-2.5 inline-flex m-2">
              <div className="text-[#ff5b27] text-[10px] font-normal font-['GT Pressura Mono Trial'] uppercase leading-normal">OUTRO</div>
            </div>
          </div>
        </div>
      </Show>
    </div>
  );
};

export default WaveformDiv;
